import { Component, Input,  } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-unavailable-feature-modal',
  templateUrl: './unavailable-feature-modal.component.html',
  styleUrls: ['./unavailable-feature-modal.component.scss']
})
export class UnavailableFeatureModalComponent {
  @Input() title: string = "";
  @Input() image: string = "";
  @Input() attention: string = "";
  @Input() descriptionTitle: string = "";
  @Input() descriptionContent: string = "";

  constructor( protected dialogRef: NbDialogRef<UnavailableFeatureModalComponent>) { }

  cancel(): void {
    this.dialogRef.close();
  }
}
